module.exports = __webpack_public_path__ + "static/media/phone.d663d882.gif";